exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control-room-listing__intro[data-v-e9bcd038]{max-width:48rem;color:#6b7b93}.control-room-listing__stack[data-v-e9bcd038]{display:grid;gap:.1rem}.control-room-listing__status-pill[data-v-e9bcd038]{white-space:normal;text-align:left;line-height:1.35}.rotate-animation[data-v-e9bcd038]{animation:control-room-spin-e9bcd038 .85s linear infinite}@keyframes control-room-spin-e9bcd038{to{transform:rotate(1turn)}}", ""]);

// exports
